import React from 'react';
import { Button, Icon, Tag, Tooltip, useMediaQueryContext } from '@fourthwall/components';
import { CloseIcon } from '@fourthwall/icons';
import { useWebViewBridge } from '@fourthwall/webview-bridge';
import * as S from './styled';
export const Suggestion = ({ award, title, description, badge, content, sideContent, topLevelContent, buttonAppearance, buttonLabel, buttonHref, buttonTo, buttonTarget, buttonLoading, buttonDisabled, imageUrl, size = 'medium', analytics, onButtonClick, onDismiss, }) => {
    const { isWebView } = useWebViewBridge();
    const media = useMediaQueryContext();
    const renderDismissButton = () => {
        if (isWebView)
            return null;
        if (!onDismiss)
            return null;
        return (React.createElement(S.DismissButtonContainer, null,
            React.createElement(Tooltip, { reference: React.createElement(S.DismissButton, { onClick: onDismiss },
                    React.createElement(Icon, { component: CloseIcon, height: 12 })) }, "Dismiss")));
    };
    const renderContent = () => (content ? React.createElement(S.Content, null, content) : null);
    const renderButton = () => {
        return buttonLabel ? (React.createElement(S.ButtonContainer, null,
            React.createElement(Button, { label: buttonLabel, to: buttonTo, href: buttonHref, target: buttonTarget, appearance: buttonAppearance || size === 'large' ? 'primary' : 'secondary', size: "small", loading: buttonLoading, disabled: buttonDisabled, analytics: analytics, onClick: onButtonClick, fullWidth: true }))) : null;
    };
    const renderSideContent = () => {
        if (sideContent) {
            return React.createElement(S.SideContent, null, sideContent);
        }
        if (imageUrl) {
            return (React.createElement(S.SideContent, null,
                React.createElement(S.Image, { src: imageUrl })));
        }
        return null;
    };
    return (React.createElement(S.Container, { size: size, "data-testid": "Suggestion" },
        React.createElement(S.Main, null,
            React.createElement(S.TextualContent, null,
                topLevelContent && React.createElement(S.TopLevelContent, null, topLevelContent),
                React.createElement(S.Title, null,
                    title,
                    award && React.createElement(S.Award, null, award),
                    badge && (React.createElement(S.Badge, null,
                        React.createElement(Tag, { ...badge, display: "inline-flex" })))),
                description && React.createElement(S.Description, null, description)),
            !media.tablet && renderSideContent(),
            media.tablet && (React.createElement(React.Fragment, null,
                renderContent(),
                renderButton()))),
        media.tablet && renderSideContent(),
        !media.tablet && (React.createElement(React.Fragment, null,
            renderContent(),
            renderButton())),
        renderDismissButton()));
};
